import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import Home from '@/pages/Home';
import SignupPage from '@/pages/SignupPage';
import ContactPage from '@/pages/ContactPage';
import FAQPage from '@/pages/FAQPage';
import AboutPage from '@/pages/AboutPage';
import BlogList from '@/pages/BlogList';
import BlogDetail from '@/pages/BlogDetail';
import AdFormatsIndex from '@/pages/ad-formats/AdFormatsIndex';
import AdFormatDetail from '@/pages/ad-formats/AdFormatDetail';
import VerticalsIndex from '@/pages/verticals/VerticalsIndex';
import VerticalDetail from '@/pages/verticals/VerticalDetail';
import FeaturesIndex from '@/pages/features/FeaturesIndex';
import FeatureDetail from '@/pages/features/FeatureDetail';
import LegalPage from '@/pages/LegalPage';
import CookiePolicy from '@/pages/CookiePolicy';
import LeadGenIndex from '@/pages/lead-gen/LeadGenIndex';
import LeadGenDetail from '@/pages/lead-gen/LeadGenDetail';
import CaseStudiesIndex from '@/pages/case-studies/CaseStudiesIndex';
import CaseStudyDetail from '@/pages/case-studies/CaseStudyDetail';
import AdminLeads from '@/pages/admin/AdminLeads';
import NotFound from '@/pages/NotFound';

import ScrollToTop from '@/components/layout/ScrollToTop';
import SiteShell from '@/components/layout/SiteShell';
import RouteProgressBar from '@/components/transitions/RouteProgressBar';
import { ConsentProvider } from '@/lib/consent';
import CookieBanner from '@/components/consent/CookieBanner';
import CookiePreferencesModal from '@/components/consent/CookiePreferencesModal';
import ConsentScripts from '@/components/consent/ConsentScripts';

function App() {
  return (
    <HelmetProvider>
      <ConsentProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <RouteProgressBar />
            <Routes>
              {/* Admin (no shell) */}
              <Route path="/admin/leads" element={<AdminLeads />} />

              {/* Public site */}
              <Route element={<SiteShell />}>
                <Route path="/" element={<Home />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/apply" element={<SignupPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/ad-formats" element={<AdFormatsIndex />} />
                <Route path="/ad-formats/:slug" element={<AdFormatDetail />} />
                <Route path="/verticals" element={<VerticalsIndex />} />
                <Route path="/verticals/:slug" element={<VerticalDetail />} />
                <Route path="/features" element={<FeaturesIndex />} />
                {/* Legacy slug redirect: /features/source-control -> /features/source-level-control */}
                <Route path="/features/source-control" element={<Navigate to="/features/source-level-control" replace />} />
                <Route path="/features/:slug" element={<FeatureDetail />} />
                <Route path="/lead-generation" element={<LeadGenIndex />} />
                <Route path="/lead-generation/:slug" element={<LeadGenDetail />} />
                <Route path="/case-studies" element={<CaseStudiesIndex />} />
                <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
                <Route path="/privacy-policy" element={<LegalPage doc="privacy" />} />
                <Route path="/terms-and-conditions" element={<LegalPage doc="terms" />} />
                <Route path="/acceptable-use-policy" element={<LegalPage doc="acceptable-use" />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
            {/* Cookie consent UI mounted globally so it appears across every route, including /admin */}
            <CookieBanner />
            <CookiePreferencesModal />
            <ConsentScripts />
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </div>
      </ConsentProvider>
    </HelmetProvider>
  );
}

export default App;
